module.exports = __webpack_public_path__ + "assets/ed3146aacf9bfad1dd12fd1779cc4880.mp4";